<template>
  <component :is="fieldLayoutComponent" ref="field" :content="content">
    <div class="d-grid gap-3">
      <radio-buttons-boxes ref="radio" input-name="event[virtual]" :options="virtualOptions" :initial-value="virtual"
                           @change="setVirtual" />

      <virtual-location-kind-selector v-if="virtual"
                                      :value="location"
                                      class="virtual-location-kind-selector"
                                      @changed="updateLocationAndTimezone"
                                      @location-kind-changed="setVirtualLocationKind" />

      <template v-else>
        <unconfirmed-location-field />
        <location-editor ref="editor"
                         :autocomplete-placeholder="i18n.t('member.events.form.physical_location_autocomplete_placeholder')"
                         :venue-label="venueLabel"
                         :country-options="countryOptions"
                         :display-region="displayRegion"
                         :exclude-venue-field="false"
                         :initial-value="location"
                         :supports-extra-info="true"
                         :valid-address-types="validAddressTypesForLocation"
                         :validation-errors="locationValidationErrors"
                         parent-entity-namespace="event"
                         @changed="updateLocationAndTimezone" />
        <hide-address-field />
      </template>
    </div>
  </component>
</template>

<script>
import HideAddressField from './hide-address-field'
import LocationEditor from '@/components/inputs/location-editor'
import UnconfirmedLocationField from './unconfirmed-location-field'
import RadioButtonsBoxes from '@/components/inputs/radio-buttons-boxes'
import FieldLayout from '@/campaign-form-shared/field-layout'
import FieldMixin from '@/campaign-form-shared/field-mixin'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import VirtualLocationKindSelector from './virtual-location-kind-selector'

export default {
  components: { FieldLayout, HideAddressField, LocationEditor, RadioButtonsBoxes, VirtualLocationKindSelector, UnconfirmedLocationField },

  mixins: [ FieldMixin ],

  props: {
    fieldLayoutComponent: {
      type: Object,
      required: false,
      default() { return FieldLayout}
    }
  },

  data() {
    return {
      virtualOptions: [[
        this.i18n.t('member.events.location.virtual_option'), true
      ], [
        this.i18n.t('member.events.location.in_person_option'), false
      ]]
    }
  },

  computed: {
    ...mapState(['countryOptions', 'displayRegion']),
    ...mapGetters(['location', 'locationValidationErrors', 'unconfirmedLocation', 'validAddressTypesForLocation', 'virtual']),

    venueLabel() {
      return this.unconfirmedLocation ? this.i18n.t('member.events.venue_field_label_unconfirmed') : this.i18n.t('components.location_editor.venue_label')
    }
  },

  methods: {
    ...mapMutations(['setValue', 'setVirtual', 'setVirtualLocationKind']),
    ...mapActions(['updateLocationAndTimezone']),

    reset() {
      this.$refs.radio.reset()
      this.$refs.editor.reset()
    }
  }
}
</script>
